import { v4 as uuidv4 } from 'uuid';

import { listElephants } from '../models/elephants';
import { getAssessment } from '../models/assessments';
import { listSectionBsByAssessment, saveSectionB} from '../models/sectionb';
import { listSectionAsByAssessment, saveSectionA} from '../models/sectiona';
import { listSectionCsByAssessment, saveSectionC} from '../models/sectionc';
//import { listSectionCIoAsByAssessment, saveSectionCIoA, completeSectionCIoA } from '../models/sectioncioa';

import { today } from './datetime';

/*
{assessment_id: '', complete_a: true, complete_b: true, complete_c: true, complete_cioa: true, complete_final: true, user_id: guid, is_online: true}
*/


const sectionCbehaviors = [
  "feeding",
  "lying_down_alone",
  "lying_down_with_others",
  "stereotyping",
  "self_maintenance",
  "interaction_with_environment",
  "social_affiliative",
  "other",
  "out_of_view",
];

const behaviors = [
  "wallowing",
  "feeding",
  "foraging",
  "locomotion",
  "stereotyping",
  "environmental_interaction",
  "affiliative_giving",
  "affiliative_receiving",
  "agonistic_giving",
  "agonistic_receiving",
  "playing_with_others",
  "anticipating"
];

const behaviorsWithDescriptions = [
  "stereotyping",
  "environmental_interaction",
  "affiliative_giving",
  "affiliative_receiving",
  "agonistic_giving",
  "agonistic_receiving",
  "playing_with_others",
  "anticipating"
]

const behaviorsWithLocations = [
  "stereotyping",
]

const behaviorsWithElephants = [
  "affiliative_giving",
  "affiliative_receiving",
  "agonistic_giving",
  "agonistic_receiving",
  "playing_with_others",
]

const descriptions = [
  "Calm and quiet.",
  "Active near the water.",
  "Seemed agitated.",
  "Following another elephant.",
  "Interacting with a keeper.",
  "Standing alone.",
  "Displaying vocalizations.",
  "Investigating surroundings.",
  "Rolling in mud.",
  "Moving quickly.",
  "Lying down.",
  "Trumpeting.",
  "Slow pacing.",
  "Dust bathing.",
  "Chewing on branches.",
  "Close to the fence.",
  "Displaying social bonding.",
  "Eating from a feeder.",
  "Attempting to reach outside.",
  "Using trunk actively."
];

const locations = [
  "North Enclosure",
  "South Enclosure",
  "East Yard",
  "West Yard",
  "Indoor Barn",
  "Training Area"
];


  const weather = [
    "Sunny",
    "Partly Cloudy",
    "Cloudy",
    "Overcast",
    "Light Rain",
    "Heavy Rain",
    "Thunderstorm",
    "Snow",
    "Fog",
    "Windy"
  ];



const getRandomSubset = (values, exclude, removeZero) => {
    // Filter out the excluded string
    const filtered = values.filter(v => v !== exclude);

    // Determine how many strings to return (between 0 and 3)
    const count = Math.floor((removeZero) ? ((Math.random() * 3) + 1) : (Math.random() * 4)); // 0,1,2,3   or  1,2,3

    // Shuffle the filtered array
    const shuffled = filtered.sort(() => Math.random() - 0.5);

    // Return the first `count` items
    return shuffled.slice(0, count);
}

const getRandomSectionAScore = () => {
    const num = Math.random() * 10;
    return Math.round(num * 10) / 10;
}

const getRandomString = (inputs) => {
  const index = Math.floor(Math.random() * inputs.length);
  return inputs[index];
};

const getRandomTimestamp = (start, end) => {
  const diff = end.unix() - start.unix();
  const offset = Math.floor(Math.random() * diff);
  return start.clone().add(offset, 'second');
};


const prepareAssessment = async({assessment_id}) => {
    try {

        const assessment = await getAssessment(assessment_id);
        console.log("fill assessment", assessment);
        if (!!assessment.id === false) throw new Error("Could not locate assessment with id: " + assessment_id);


        const elephants = await listElephants();
        const elephantIds = elephants.map((cur)=>(cur.id));

        const elephantList = (removeZero) => {
            const otherElephants = getRandomSubset(elephantIds, assessment.elephantIds, removeZero);
            console.log("fill other elephants", otherElephants);
            return otherElephants;
        }

        return {assessment, elephants, elephantList};

    } catch (error) {
        throw error;
    }
}


const fillAssessmentsWithFakeData = async ({assessment_id, complete_a, complete_b, complete_c, complete_cioa, complete_final, user_id, is_online, is_overwrite = true}) => {
	try {

		if (complete_a) {
            await fillSectionAWithFakeData({assessment_id, user_id, is_online, overwrite: is_overwrite});
		}

		if (complete_b) {
            await fillSectionBWithFakeData({assessment_id, user_id, is_online, overwrite: is_overwrite});
		}

		if (complete_c) {
            await fillSectionCWithFakeData({assessment_id, user_id, is_online, overwrite: is_overwrite});
		}


	} catch (error) {
		throw error;
	}
}

/*
Example Payload
{
    "id": "dea7bc34-61e5-4b7a-bdcd-9a70d329479a",
    "assessment_id": "2c2fe853-2e39-4af4-bdf4-af91f6215896",
    "user_id": "9f2a577e-edb5-4a6e-b983-641bd8d70fc0",
    "observed_on": "2025-06-08T17:12:56.552Z",
    "observation_range": "08:00 - 10:15",
    "submitted_on": "2025-06-08T17:14:29.044Z",
    "completed_on": null,
    "other_elephants_nearby": [
        "0f5efd11-02a0-4f3c-90ff-4089fe35fba4",
        "5f413af5-06de-424d-81a8-0e6e3e92753f"
    ],
    "content": 9.6,
    "uncomfortable": 4.4,
    "relaxed": 5.9,
    "agitated": 7.5,
    "tense": 10,
    "frustrated": 8.1,
    "wary": 9.1,
    "playful": 0,
    "sociable": 0.3,
    "lively": 0.7,
    "lethargic": 9.2,
    "sort_order": 0,
    "sync": 1749402869.044
}
*/

const fillSectionAWithFakeData = async ({assessment_id, user_id, is_online, overwrite = false, now = today()}) => {
  try {
    const {assessment, elephantList} = await prepareAssessment({assessment_id})

    const allSectionAs = await listSectionAsByAssessment(assessment.id);
    console.log("fill section a", allSectionAs);

    const filteredSectionAs = allSectionAs.filter((cur)=>{
      return (overwrite === true) ? true : cur.submitted_on === null;
    });
    console.log("fill filtered section a", filteredSectionAs);

    const start = now.clone().subtract(1,'minute');

    const sectionApromiseList = filteredSectionAs.map(async (cur)=>{

      const payload = {
        ...cur,
        completed_on: undefined,
        observed_on: start,
        submitted_on: now,
        user_id: user_id,
        other_elephants_nearby: elephantList(),
        content: getRandomSectionAScore(),
        uncomfortable: getRandomSectionAScore(),
        relaxed: getRandomSectionAScore(),
        agitated: getRandomSectionAScore(),
        tense: getRandomSectionAScore(),
        frustrated: getRandomSectionAScore(),
        wary: getRandomSectionAScore(),
        playful: getRandomSectionAScore(),
        sociable: getRandomSectionAScore(),
        lively: getRandomSectionAScore(),
        lethargic: getRandomSectionAScore(),
      }
      console.log("fill payload", payload);

      return await saveSectionA(payload,is_online)
    });

    console.log("fill", sectionApromiseList);
    const sectionAPromiseResults = await Promise.all(sectionApromiseList);
    console.log("fill section a promise results", sectionAPromiseResults);

    return sectionAPromiseResults;
  } catch (error) {
      throw error;
  }
}

/*
{
  "id": "56125f7e-8b43-4eed-9a41-3430542490eb",
  "assessment_id": "2c2fe853-2e39-4af4-bdf4-af91f6215896",
  "user_id": "9f2a577e-edb5-4a6e-b983-641bd8d70fc0",
  "observed_on": "2025-06-08T17:52:41.586Z",
  "observation_range": "Day 1: 08:00 - 10:15",
  "submitted_on": null,
  "completed_on": null,
  "current_weather_conditions": null,
  "other_elephants_nearby": [],
  "wallowing": 0,
  "feeding": 0,
  "foraging": 0,
  "locomotion": 0,
  "stereotyping": 1,
  "environmental_interaction": 0,
  "affiliative_giving": 0,
  "affiliative_receiving": 1,
  "agonistic_giving": 1,
  "agonistic_receiving": 0,
  "playing_with_others": 0,
  "anticipating": 0,
  "behaviors": [
    {
      "id": "1eab0564-d22a-4758-9d6a-6faca8284207",
      "section_b_id": "56125f7e-8b43-4eed-9a41-3430542490eb",
      "observed_on": "2025-06-08T17:56:21.989Z",
      "behavior": "stereotyping",
      "description": "Head bobbing\nTrunk swinging",
      "location": "Pen1",
      "associated_elephants": [],
      "sync": 1749405490.597
    },
    {
      "id": "b372ba65-81fc-4024-a2b2-c1d148656178",
      "section_b_id": "56125f7e-8b43-4eed-9a41-3430542490eb",
      "observed_on": "2025-06-08T17:56:30.944Z",
      "behavior": "affiliative_receiving",
      "description": "Sparring",
      "location": "",
      "associated_elephants": [
        "c21d0c90-69c6-43ef-b1d1-6a71397a0475"
      ],
      "sync": 1749405490.597
    },
    {
      "id": "a9a9f869-af7a-4d3b-a581-4929dd3c4fe2",
      "section_b_id": "56125f7e-8b43-4eed-9a41-3430542490eb",
      "observed_on": "2025-06-08T17:58:10.482Z",
      "behavior": "agonistic_giving",
      "description": "fff\nChasing",
      "location": "",
      "associated_elephants": [
        "8ed16928-a5f1-49bd-b500-4b692b9ae292"
      ],
      "sync": 1749405490.597
    }
  ],
  "comments": null,
  "sort_order": 0,
  "sync": 1749405490.597
}
*/

const fillSectionBWithFakeData = async ({assessment_id, user_id, is_online, overwrite = false, now = today()}) => {
  try {

    const generateBehaviorRecords = (section_b_id, start, end, count) => {
      const actualCount = count ?? (Math.floor(Math.random() * 10) + 3); // 3–12

      return Array.from({ length: actualCount }, () => {
        const behavior = getRandomString(behaviors);
        return ({
          id: uuidv4(),
          section_b_id,
          observed_on: getRandomTimestamp(start, end),
          behavior: behavior,
          description: (behaviorsWithDescriptions.includes(behavior)) ? getRandomString(descriptions) : null,
          location: (behaviorsWithLocations.includes(behavior)) ? getRandomString(locations) : null,
          associated_elephants: (behaviorsWithElephants.includes(behavior)) ? elephantList(true) : [],
        })
      });
    };


    const countBehaviors = (behaviorRecords) => {
      // Initialize count map with all behaviors set to 0
      const behaviorCounts = Object.fromEntries(
        behaviors.map((b) => [b, 0])
      );

      // Tally behavior instances from the input array
      for (const record of behaviorRecords) {
        if (behaviorCounts.hasOwnProperty(record.behavior)) {
          behaviorCounts[record.behavior]++;
        }
      }

      return behaviorCounts;
    };



    const {assessment, elephantList} = await prepareAssessment({assessment_id})

    const allSectionBs = await listSectionBsByAssessment(assessment.id);
    console.log("fill section b", allSectionBs);

    const filteredSectionBs = allSectionBs.filter((cur)=>{
      return (overwrite === true) ? true : cur.submitted_on === null;
    });
    console.log("fill filtered section b", filteredSectionBs);

    const start = now.clone().subtract(5,'minute');


    const promiseList = filteredSectionBs.map(async (cur)=>{

      const behaviorRecords = Array.isArray(cur.behaviors) && cur.behaviors.length > 0
        ? cur.behaviors.map((existing) => {
            const behavior = getRandomString(behaviors);
            return {
              ...existing,
              observed_on: getRandomTimestamp(start, now),
              behavior,
              description: behaviorsWithDescriptions.includes(behavior) ? getRandomString(descriptions) : null,
              location: behaviorsWithLocations.includes(behavior) ? getRandomString(locations) : null,
              associated_elephants: behaviorsWithElephants.includes(behavior) ? elephantList(true) : [],
            };
          })
        : generateBehaviorRecords(cur.id, start, now);

      const behaviorCounts = countBehaviors(behaviorRecords);
      console.log("fill section b behavior counts", behaviorCounts);

      const payload = {
        ...cur,
        completed_on: undefined,
        observed_on: start,
        submitted_on: now,
        user_id: user_id,
        other_elephants_nearby: elephantList(),
        current_weather_conditions: getRandomString(weather),
        behaviors: behaviorRecords,
        ...behaviorCounts,
      }

      console.log("fill section b payloads", payload);
      return await saveSectionB(payload,is_online);
    });


    const sectionBPromiseResults = await Promise.all(promiseList);
    console.log("fill section b promise results", sectionBPromiseResults);

    return sectionBPromiseResults;


  } catch (error) {
    throw error;
  }
}

/*
"wallowing",
"feeding",
"foraging",
"locomotion",
"stereotyping",
"environmental_interaction",
"affiliative_giving",
"affiliative_receiving",
"agonistic_giving",
"agonistic_receiving",
"playing_with_others",
"anticipating",
*/


/*

{
  "id": "857443fb-54d9-4b1e-9499-36b258cc06c3",
  "assessment_id": "2c2fe853-2e39-4af4-bdf4-af91f6215896",
  "user_id": "9f2a577e-edb5-4a6e-b983-641bd8d70fc0",
  "observation_range": "17:30",
  "observed_on": "2025-06-08T19:58:36.374Z",
  "submitted_on": null,
  "completed_on": null,
  "feeding": false,
  "lying_down_alone": false,
  "lying_down_with_others": false,
  "lying_down_with_others_elephants": [],
  "stereotyping": false,
  "stereotyping_description": null,
  "self_maintenance": false,
  "self_maintenance_description": null,
  "interaction_with_environment": false,
  "interaction_with_environment_description": null,
  "social_affiliative": false,
  "social_affiliative_elephants": [],
  "other": false,
  "other_description": null,
  "out_of_view": false,
  "additional_comments": null,
  "sort_order": 1,
  "sync": 1749412716.375
}

{
  "id": "d085ebf6-9216-4aed-b287-a6249f5f996b",
  "assessment_id": "2c2fe853-2e39-4af4-bdf4-af91f6215896",
  "user_id": "9f2a577e-edb5-4a6e-b983-641bd8d70fc0",
  "observation_range": "18:00",
  "observed_on": "2025-06-08T19:59:02.675Z",
  "submitted_on": "2025-06-08T20:01:44.046Z",
  "completed_on": null,

  "feeding": false,
  "lying_down_alone": false,
  "lying_down_with_others": false,
  "lying_down_with_others_elephants": [],
  "stereotyping": true,
  "stereotyping_description": "stereo1",
  "self_maintenance": false,
  "self_maintenance_description": null,
  "interaction_with_environment": false,
  "interaction_with_environment_description": null,
  "social_affiliative": false,
  "social_affiliative_elephants": [],
  "other": false,
  "other_description": null,
  "out_of_view": false,
  "additional_comments": "aabb",
  "sort_order": 2,
  "sync": 1749412904.047
}

*/

const fillSectionCWithFakeData = async ({assessment_id, user_id, is_online, overwrite = false, now = today()}) => {
  try {
    const {assessment, elephantList} = await prepareAssessment({assessment_id})

    const allSections = await listSectionCsByAssessment(assessment.id);
    console.log("fill section c", allSections);

    const filteredSections = allSections.filter((cur)=>{
      return (overwrite === true) ? true : cur.submitted_on === null;
    });
    console.log("fill filtered section c", filteredSections);

    //const start = now.clone().subtract(1,'minute');


    const getRandomComment = () => {
      const comments = [
        "Animal was calm during the procedure.",
        "Displayed minor resistance when approached.",
        "Excellent behavior today.",
        "Required distraction techniques.",
        "Showed signs of stress near end.",
        "Very alert and responsive.",
        "Minimal interaction observed.",
        "Interacted positively with handlers.",
        "Feeding behavior normal.",
        "Vocalizations increased after noon.",
        "Grooming behavior observed.",
        "Group behavior remained stable.",
        "No unusual signs noted.",
        "Needed additional encouragement.",
        "Slightly more restless than usual.",
        "Excellent interaction with enrichment.",
        "Quick to respond to stimuli.",
        "Showed interest in surroundings.",
        "Took time to settle down.",
        "Calm and cooperative overall."
      ];

      return Math.random() < 0.5
        ? null
        : comments[Math.floor(Math.random() * comments.length)];
    };



    const promiseList = filteredSections.map(async (cur)=>{

      const localBehavior = getRandomString(sectionCbehaviors);

      const payload = {
        ...cur,
        completed_on: undefined,
        observed_on: now,
        submitted_on: now,
        user_id: user_id,
        additional_comments: getRandomComment(),

        behavior: localBehavior,
        description: (['stereotyping','self_maintenance', 'interaction_with_environment', 'other'].includes(localBehavior)) ? getRandomString(descriptions) : null,
        associated_elephants: (['lying_down_with_others','social_affiliative'].includes(localBehavior)) ? elephantList(true) : [],
      }
      console.log("fill payload", payload);

      return await saveSectionC(payload,is_online)
    });

    console.log("fill", promiseList);
    const promiseResults = await Promise.all(promiseList);
    console.log("fill section c promise results", promiseResults);

    return promiseResults;

  } catch (error) {
      throw error;
  }
}

export {fillAssessmentsWithFakeData};